import { render } from "./AccountDialog.vue?vue&type=template&id=47ea0602&scoped=true&ts=true"
import script from "./AccountDialog.vue?vue&type=script&lang=ts"
export * from "./AccountDialog.vue?vue&type=script&lang=ts"

import "./AccountDialog.vue?vue&type=style&index=0&id=47ea0602&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ea0602"]])

export default __exports__